import DistributionGroup from "./distribution-group";

export default DistributionGroup;
